module.exports = __webpack_public_path__ + "img/added-service-unit-04.27d26704.png";